export const tieredMenuPt = () => {
  return {
    itemLabel: {
      class: 'font-14-n'
    }
  }
}
